
import { Alert, AlertTitle, Box, Button, Card } from "@mui/material";
import { useSelector } from "react-redux";
import VerifyPermission from "../../../../utils/verifyPermission";
import { useNavigate, useParams } from "react-router-dom";
import { temPermissao } from "../../../../utils/permissoes";
import AnaliseNarranjo from "./analiseNarranjo";
import ObservacoesFeitas from "../../dlif/observacoesFeitas";
import Relatorios from "../../../../relatorioEspontaneo/relatoriosEspontaneos";

export default function NavLateral({ notificacao, observacoesFeitas }) {
  const user = useSelector((state) => state.account.user);
  const { id, action } = useParams();
  const navigate = useNavigate();


  return (
    <>
      <Card style={{ padding: 20, marginBottom: 10 }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", placeItems: 'center' }}>
          <img src="/icones/controleQualidade/solicitacoesAnalise.svg" alt="img" width={'80%'} />
        </div>

        <br />
        {/* {notificacao?.status === "Director Geral" ?
          <Alert severity={'success'}>
            <AlertTitle>  Estado da Notificação:</AlertTitle>
            <b> Concluido</b>
          </Alert>
          : */}

        <Box>

          <Alert severity={notificacao?.status === 'Aprovado' ? 'success' : notificacao?.status === 'Indeferido' ? 'error' : ''}>
            <AlertTitle>  Estado solicitação:</AlertTitle>
            <b> {notificacao?.status?.toUpperCase()}</b>
          </Alert>

          {/* Aqui será feita a Avaliação Técnica */}
          {(notificacao?.status === "Análise" || notificacao?.status === "Pendente") && (
            <>
              {notificacao?.tipo === 'Notificação de Reações Adversas a Medicamentos e Producto Sanitários' &&
                <VerifyPermission permissions={user?.permissions} permission={''}>
                  <AnaliseNarranjo idNotificacao={notificacao?._id} />
                </VerifyPermission>
              }

              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaAnalise'])}
                style={{ marginTop: 5 }}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/approve/Chefe de Área/${id}`)}
              >
                Encaminhar para Chefe de Área
              </Button>

              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaAnalise'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/repprove/Indeferido/${id}`)}
              >
                Descartar Notificação
              </Button>
            </>
          )}


          {notificacao?.status === "Chefe de Área" && (
            <>
              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaChefeArea'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/approve/Chefe de Departamento/${id}`)}
              >
                Encaminhar para Chefe de Departamento
              </Button>

              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaChefeArea'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/repprove/Análise/${id}`)}
              >
                Voltar para Análise
              </Button>
            </>
          )}

          {notificacao?.status === "Chefe de Departamento" && (
            <>
              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaChefeDepartamento'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/approve/Directora Geral Adjunta para os Serviços Executivos/${id}`)}
              >
                Encaminhar para Directora Geral Adjunta para os Serviços Executivos
              </Button>

              {/* ENCAMINHAR O PROCESSO PARA AREA DE CONTROLO DE QUALIDADE */}
              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaChefeDepartamento'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "areacq" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/areacq/Controle de Qualidade/${id}`)}
              >
                Encaminhar para Área de Controlo de Qualidade
              </Button>

              {/* ENCAMINHAR O PROCESSO PARA AREA DE INSPECCAO */}
              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaChefeDepartamento'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "areai" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/areai/Inspecção/${id}`)}
              >
                Encaminhar para Área Inspecção
              </Button>

              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaChefeDepartamento'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/repprove/Chefe de Área/${id}`)}
              >
                Voltar para Chefe de Área
              </Button>
            </>
          )}

          {(notificacao?.status === "Controlo de Qualidade" || notificacao?.status === "Inspecção") && (
            <Button
              disabled={!temPermissao(user, ['farmacovigilanciaInspeccao', 'farmacovigilanciaControloQualidade'])}
              fullWidth
              size="small"
              color="success"
              variant={action === "approve" ? "contained" : "outlined"}
              onClick={() => navigate(`/admin/dftec/farmacovigilancia/approve/Chefe de Departamento/${id}`)}
            >
              Encaminhar para Farmacovigilancia Chefe de Departamento
            </Button>
          )}

          {notificacao?.status === "Directora Geral Adjunta para os Serviços Executivos" && (
            <>
              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaDirectoraGeralAdjunta'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/approve/Director Geral/${id}`)}
              >
                Encaminhar para Director Geral
              </Button>

              <Button
                disabled={!temPermissao(user, ['farmacovigilanciaDirectorGeral'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/repprove/Chefe de Departamento/${id}`)}
              >
                Voltar para Directora Geral Adjunta para os Serviços Executivos
              </Button>
            </>
          )}

          {notificacao?.status === "Director Geral" && (
            <>
              {/* <Button
                // disabled={!temPermissao(user, [''])}
                disabled={true}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/approve/Director Geral/${id}`)}
              >
                 ####
              </Button> */}

              <Button
                disabled={!temPermissao(user, [''])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dftec/farmacovigilancia/repprove/Directora Geral Adjunta para os Serviços Executivos/${id}`)}
              >
                Voltar para Directora Geral Adjunta para os Serviços Executivos
              </Button>
            </>
          )}
        </Box>
      </Card>

      {/* RELATORIOS ESPOTANEOS */}
      <Relatorios processoId={notificacao?._id} modelName="farmacovigilancia" />

      {observacoesFeitas?.length > 0 && (
        <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
      )}

    </>
  );
}
